<template>
    <el-dialog @close='closeDialog' title="批量导入商品素材" :visible.sync="dialogVisible">
        <div class="goods_material_box">
            <div class="left_box">
                <p @click="goodsClassClick(-1)" :class="classMenu === -1 ? 'isactive' : 'noactive'">全部分类</p>
                <p @click="goodsClassClick(index, item.innerid)" :class="classMenu === index ? 'isactive' : 'noactive'" v-for="(item, index) in goodsClassData" :key="index">{{item.name}}</p>
            </div>
            <div class="right_box">
                <div class="goods_class_list_box">
                    <el-table max-height="424" :data="goodsData" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable">
                        <el-table-column type="selection" width="30"></el-table-column>
                        <el-table-column label="商品名称" prop="name">
                            <template slot-scope="scope">
                                <div class="goods_info_box1">
                                    <img :src="scope.row.logoatturlid" alt="">
                                    <div>
                                        <p>{{scope.row.name}}</p>
                                        <p>{{scope.row.saleprice}}</p>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sureClick()">确 定</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {searchMaterials, getMaterialCategory, batchProductInfo} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'BatchImport',
    data() {
        return {
            goodsClassId: '',
            classMenu: -1,
            dialogVisible: false,
            goodsData: [],
            selectedResult: [],
            goodsClassData: []
        }
    },
    mounted() {},
    methods: {
        // 获取分类列表
        getGoodsClass() {
            this.setLoading(true)
            getMaterialCategory({
                // data: Object.assign({}),
                success: data => {
                    this.setLoading(false)
                    this.goodsClassData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 商品分类搜索
        goodsClassClick(val, classId) {
            this.classMenu = val
            this.page.page = 1
            if (val === -1) {
                this.goodsClassId = ''
                this.findGoodsList()
            } else {
                this.goodsClassId = classId
                this.findGoodsClassList(classId)
            }
        },
        // 打开弹窗
        openDialog() {
            this.dialogVisible = true
            this.goodsClassId = ''
            this.classMenu = -1
            this.getGoodsClass()
            this.findGoodsList()
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
            this.classMenu = -1
            this.selectedResult = []
        },
        // 获取商品素材
        findGoodsList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            searchMaterials({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取商品分类列表下素材
        findGoodsClassList(value) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                catecode: value
            }
            searchMaterials({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleSelectionChange(val) {
            this.selectedResult = val
        },

        // 确定添加商品
        sureClick() {
            // console.log(this.selectedResult)
            if (this.selectedResult.length === 0) {
                this.$message.error('请选择需要导入的商品！')
            } else {
                let goodsID = []
                for (let index = 0; index < this.selectedResult.length; index++) {
                    goodsID.push(this.selectedResult[index].innerid)
                }
                goodsID = goodsID.join(',')
                // console.log(goodsID)
                this.setLoading(true)
                var params = {
                    eventinnerid: this.$route.query.eventinnerid,
                    inneridList: goodsID
                }
                batchProductInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.dialogVisible = false
                        this.$emit('getGoodsList')
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .goods_material_box{
        background-color: rgb(255, 255, 255);
        height: 528px;
        display: flex;
        justify-content: space-between;
        .left_box{
            overflow-y: scroll;
            overflow-x: hidden;
            // overflow-y: auto;
            // border-right: 1px solid #DCDFE6;
            p{
                width: 150px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fff;
                color: #36383A;
                cursor: pointer;
            }
            p:hover{
                background-color: #E6F1FC;
                color: #409EFF;
            }
            .isactive{
                background-color: #E6F1FC;
                color: #409EFF;
            }
        }
        .right_box{
            flex: 1;
            padding: 10px;
            .goods_class_list_box{
                margin-bottom: 30px;
                .el-table th>.cell {
                    font-weight: bold!important;
                    white-space: nowrap;
                    font-size: 16px;
                }
                // .el-table__empty-block {
                //     min-height: 300px;
                // }
                .el-table__body-wrapper {
                    min-height: 368px;
                }
                .el-table__empty-block {
                    box-sizing: border-box;
                    padding-top: 140px;
                    min-height: 368px;
                    // background-size: 300px 230px !important;
                }
                .goods_info_box1{
                    // background-color: #fff;
                    padding: 0;
                    display: flex;
                    &>img{
                        width: 50px;
                        height: 50px;
                        margin-right: 18px;
                    }
                    &>div{
                        // background-color: rgb(255, 255, 255);
                        // padding: 5px 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        p:nth-of-type(1){
                            color: #303133;
                        }
                        p:nth-of-type(2){
                            color: #F56C6C;
                        }
                    }
                }
            }
        }
    }
</style>